const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/handwork-elements`,
    saveDiscountTable: `${API_URL}/handwork-element/save-discount-table`
};

export default apiUrls;
